/*
  This function should be used on base URLs which include a port
  That is urls in the form {protocol}://{ip}:{port}
  It will extract the different url segments and return them as an object
**/
export const extractUrlSegments = (url: string) => {
  const urlSegments = url.split(':')
  if (urlSegments.length !== 3) {
    console.error('invalid url', url)
    return {
      protocol: '',
      ip: '',
      port: ''
    }
  }

  // ['http', '//localhost', '8888']
  // using slice to remove '//' from ip url segment
  const protocol = urlSegments[0] || ''
  const ip = urlSegments[1]?.slice(2) || ''
  let port = urlSegments[2] || ''

  if (port.includes('/')) {
    port = port.split('/')[0]
  }
  return {
    protocol,
    ip,
    port
  }
}
